<template>
  <b-card :title="$t('labels.currencies')">
    <b-overlay :show="loadingData" variant="transparent" no-wrap />
    <!-- modal edit-->
    <b-modal
      ref="my-modal"
      id="modal-currency"
      centered
      hide-footer
      :title="`${$t('labels.editCurrency')}: ${formData.name}`"
    >
      <b-form @submit.prevent="updateForm">
        <b-form-group :label="$t('labels.name')">
          <b-form-input
            v-model="formData.name"
            type="text"
            :placeholder="$t('labels.name')"
          />
        </b-form-group>
        <b-form-group :label="$t('labels.description')">
          <b-form-input
            v-model="formData.description"
            type="text"
            :placeholder="$t('labels.description')"
          />
        </b-form-group>
        <b-form-group :label="$t('labels.abbreviation')">
          <b-form-input
            v-model="formData.abv"
            type="text"
            :placeholder="$t('labels.abbreviation')"
          />
        </b-form-group>
        <b-form-group :label="$t('labels.symbol')">
          <b-form-input
            v-model="formData.symbol"
            type="text"
            :placeholder="$t('labels.symbol')"
          />
        </b-form-group>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="mr-1"
        >
          {{ $t('buttons.submit') }}
        </b-button>
      </b-form>
    </b-modal>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">{{$t('labels.search')}}</label>
          <b-form-input
            v-model="searchTerm"
            :placeholder="$t('labels.search')"
            type="text"
            class="d-inline-block"
          />
          <b-button
            class="text-nowrap ml-2"
            variant="primary"
            @click="$refs.addUpdateCurrency.modalShow = true"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap">{{$t('labels.add')}}</span>
          </b-button>
          <add-update-currency  ref="addUpdateCurrency" />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <div class="table-responsive">
      <vue-good-table
        class="table"
        :columns="defineColumns()"
        :rows="rows"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item v-if="$can('edit','Currency')"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-currency
                  @click="formData = JSON.parse(JSON.stringify(props.row))"
                  variant="outline-primary"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>{{ $t('labels.edit') }}</span>
                </b-dropdown-item>
                 <b-dropdown-item :to="{ name: 'currency-detail', params: { id: props.row._id } }">
                  <feather-icon
                          icon="DollarSignIcon"
                          class="mr-50"
                  />
                  <span>{{ $t('labels.detailView') }}</span>
                </b-dropdown-item>
<!--                <b-dropdown-item @click="deleteCurrency(props.row._id)">-->
<!--                  <feather-icon icon="TrashIcon" class="mr-50" />-->
<!--                  <span>Delete</span>-->
<!--                </b-dropdown-item>-->
              </b-dropdown>
            </span>
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="[ 10, 25, 50, 100 ]"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </b-card>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  VBModal,
  BModal,
  BForm,
  BButton,
  BCard,
  BOverlay
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import { mapActions } from "vuex";
import Ripple from "vue-ripple-directive";
import AddUpdateCurrency from './addEditCurrency'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    VueGoodTable,
    BModal,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BForm,
    BButton,
    BCard,
    AddUpdateCurrency,
    BOverlay,
    ToastificationContent
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  data() {
    return {
      formData: {
        conversion_factor: {
          symbol: null,
          value: null,
        }
      },
      pageLength: 10,
      dir: false,
      searchTerm: "",
      loadingData: false
    };
  },
  computed: {
    rows() {
      return this.$store.state.currency.currencys;
    },
  },
  created() {
    this.getcurrencys();
  },
  methods: {
    ...mapActions("currency", ["currencys", "update", "destroy"]),

    defineColumns(){
      const columns = [
        {label: this.$t('tableHeader.name'), field: "name",},
        {label: this.$t('tableHeader.description'), field: "description",},
        {label: this.$t('tableHeader.abbreviation'), field: "abv",},
        {label: this.$t('tableHeader.symbol'), field: "symbol",},
        {label: this.$t('tableHeader.actions'), field: "action",}]

      return columns
    },

    async getcurrencys() {
      try {
        this.loadingData = true;
        await this.$store.dispatch("currency/currencys");
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching currency list",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: error.response ? error.response.data.message : '',
          },
        });
      } finally {
        this.loadingData = false;
      }
    },
    async updateForm() {
      try {
        const response = await this.$store.dispatch("currency/update", this.formData);
        this.$refs["my-modal"].hide();
        this.$swal({
          title: "Update Currency",
          text: response.message,
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.formData = {};
        this.getcurrencys();
      } catch (error) {
        console.log(error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error updating currency",
            icon: "AlertTriangleIcon",
            variant: "danger",
            text: `${error.response.data.message}`,
          },
        });
      }
    },
    async deleteCurrency(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const response = await this.$store.dispatch("currency/destroy", id);
            this.$swal({
              title: "Deleted!",
              text: response.message,
              icon: "success",
              customClass: {
                confirmButton: "btn btn-primary",
              },
              buttonsStyling: false,
            });
            this.getcurrencys();
          } catch (error) {
            console.log(error);
            this.$swal({
              icon: "error",
              title: "Error!",
              text: error.message,
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" >
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>